import { render, staticRenderFns } from "./Q02020.vue?vue&type=template&id=3cb90fb0&scoped=true&"
import script from "./Q02020.vue?vue&type=script&lang=js&"
export * from "./Q02020.vue?vue&type=script&lang=js&"
import style0 from "./Q02020.vue?vue&type=style&index=0&id=3cb90fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb90fb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VRow,VSelect})
